import "./App.css";
import { Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";

// Lazy Load Pages
const AddNewEvent = lazy(() => import("./Vendor/Pages/AddNewEvent"));
const LoginPage = lazy(() => import("./Vendor/Pages/LoginPage"));
const AccountSetUp = lazy(() => import("./Vendor/Pages/AccountSetUp"));
const DashBoard = lazy(() => import("./Vendor/Pages/DashBoard"));
const ManageCampaign = lazy(() => import("./Vendor/Pages/ManageCampaign"));
const TicketScan = lazy(() => import("./Vendor/Pages/TicketScan"));
const YourEvents = lazy(() => import("./Vendor/Pages/YourEvents"));
const CreateEvent = lazy(() => import("./Vendor/Pages/CreateEvent"));
const QRScanner = lazy(() => import("./Ticket-Scanner/QRScanner/QRScanner"));
const ScannedTicket = lazy(() =>
  import("./Ticket-Scanner/QRScanner/ScannedTicket")
);
const LoginGK = lazy(() => import("./Ticket-Scanner/Auth/LoginGK"));
const SucessEntry = lazy(() => import("./Vendor/Pages/SucessEntry"));
const VendorEvents = lazy(() => import("./Vendor/Pages/VendorEents"));
const EditAddNewEvent = lazy(() =>
  import("./Vendor/Components/edit_eventbyID/EditAddNewEvent")
);
const Payouts = lazy(() => import("./Vendor/Components/PayOuts"));
const VendorProfile = lazy(() => import("./Vendor/Pages/VendorProfile"));
const CorporateLoginGK = lazy(() =>
  import("./Ticket-Scanner/Auth/CorporateLoginGK")
);
const CorporateQRScanner = lazy(() =>
  import("./Ticket-Scanner/QRScanner/CorporateQRScanner")
);
const CorporateScannerTicket = lazy(() =>
  import("./Ticket-Scanner/QRScanner/CorporateScannerTicket")
);
const CorporateSucessEntry = lazy(() =>
  import("./Vendor/Pages/CorporateSucessEntry")
);

// Not Authorized Component
function NotAuthorized() {
  return (
    <div>
      <h2>Sorry! You are not authorized.</h2>
    </div>
  );
}

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/signup" element={<AccountSetUp />} />

        {/* Vendor Routes */}
        {localStorage.getItem("VendorData") ? (
          <>
            <Route path="/details" element={<AddNewEvent />} />
            <Route path="/vendor/dashboard" element={<DashBoard />} />
            <Route path="/vendor/yourevents" element={<VendorEvents />} />
            <Route path="/vendor/ticketscan" element={<TicketScan />} />
            <Route path="/vendor/create-event" element={<CreateEvent />} />
            <Route path="/vendor/campaigns" element={<ManageCampaign />} />
            <Route path="/vendor/payouts" element={<Payouts />} />
            <Route path="/vendor/profile" element={<VendorProfile />} />
            <Route
              path="/vendor/event-detail/:event_id"
              element={<YourEvents />}
            />
            <Route
              path="/vendor/editevent-detail/:event_id"
              element={<EditAddNewEvent />}
            />
          </>
        ) : (
          <Route path="*" element={<NotAuthorized />} />
        )}

        {/* Event Gate Keeper */}
        <Route
          path="/scanner/scanqr/:unique_id/:event_id"
          element={<LoginGK />}
        />
        <Route
          path="/corporate/scanner/scanqr/:unique_id/:event_id"
          element={<CorporateLoginGK />}
        />
        <Route path="/scanner/scanqr" element={<QRScanner />} />
        <Route
          path="/corporate/scanner/scanqr"
          element={<CorporateQRScanner />}
        />
        <Route path="/scanner/scanticket" element={<ScannedTicket />} />
        <Route
          path="/corporate/scanner/scanticket"
          element={<CorporateScannerTicket />}
        />
        <Route path="/scanner/entred" element={<SucessEntry />} />
        <Route
          path="/corporate/scanner/entred"
          element={<CorporateSucessEntry />}
        />
      </Routes>
    </Suspense>
  );
}

export default App;
